import type { ReactNode } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';

export const STAFF_INTAKE_TABS = [
  { value: 'overview', label: 'Overview' },
  { value: 'verification', label: 'Verification' },
  { value: 'billing', label: 'Billing' },
  { value: 'credentialing', label: 'Credentialing' },
  { value: 'ehr-import', label: 'EHR Migration' },
] as const;
export type StaffIntakeTab = (typeof STAFF_INTAKE_TABS)[number]['value'];

export function StaffIntakeStatusShell({
  selected,
  onSelect,
  children,
}: {
  selected: StaffIntakeTab;
  onSelect: (tab: StaffIntakeTab) => void;
  children: ReactNode;
}) {
  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'grey.50', minHeight: '100%' }}>
      <Typography variant="overline" color="text.secondary">
        Internal · Intake Hub
      </Typography>
      <Typography component="h1" variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Intake Status
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Review practice intake and setup status. Open an organization’s Intake Hub to continue.
      </Typography>
      <Tabs
        value={selected}
        onChange={(_event, value: StaffIntakeTab) => onSelect(value)}
        variant="scrollable"
        aria-label="Staff intake tracks"
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        {STAFF_INTAKE_TABS.map(tab => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            id={`intake-tab-${tab.value}`}
            aria-controls={`intake-panel-${tab.value}`}
          />
        ))}
      </Tabs>
      <Box
        role="tabpanel"
        id={`intake-panel-${selected}`}
        aria-labelledby={`intake-tab-${selected}`}
      >
        {children}
      </Box>
    </Box>
  );
}
